module.exports = __webpack_public_path__ + "static/media/facing_challenges.4a418f07.svg";